import React, { ReactElement } from "react";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";
import { ToelichtingHypotheekDubbeleLastenHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import { DubbeleLastenDetailsTable } from "./dubbele-lasten-details-tabel";
import { DubbeleLastenOverbruggingDetailsTable } from "./dubbele-lasten-overbrugging-tabel";

export const ToelichtingAdviesDubbeleWoonlastenChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingHypotheekDubbeleLastenHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text={hoofdstuk.titel ?? "Dubbele woonlasten"} level={3} />
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk.advies}
          keuze={hoofdstuk.keuze}
        />
      </div>
      <DubbeleLastenDetailsTable
        huidigeSituatie={hoofdstuk.huidigeSituatie}
        nieuweSituatie={hoofdstuk.nieuweSituatie}
      />
      <DubbeleLastenOverbruggingDetailsTable
        dubbeleLastenOverbruggingDetails={hoofdstuk.overbrugging}
      />
    </Chapter>
  );
};
